"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.SelectedBar = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../../styled-components");
exports.SelectedBar = styled_components_1.styled.div `
  background: ${(props) => props.selected ? props.theme.highlight : "rgba(255,255,255,0.05)"};
  width: 5px;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 1;
`;
exports.Wrapper = styled_components_1.styled.div.attrs({ tabIndex: 0 }) `
  position: relative;
  border: none;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex: 1;
  background: ${(props) => props.isSectionLabel ? "transparent" : "rgba(255, 255, 255, 0.05)"};
  padding: 5px;
  margin-bottom: 3px;
  border-radius: ${(props) => props.theme.radius};
  text-align: left;
  word-break: break-all;
  word-break: break-word;
  cursor: pointer;
  overflow: hidden;
  color: ${(props) => props.theme.fg};
  padding-left: 10px;
  outline-offset: -1px;
`;
//# sourceMappingURL=style.js.map